module.exports = __webpack_public_path__ + "static/media/After the Movie (by Plaid) - Remix Version.bc80f7ae.jpg";